export default __webpack_public_path__ + "static/media/taskhub.0f64a1a1.svg";